// extracted by mini-css-extract-plugin
export default {"blogPost":"blogPost_blogPost__+Ml3n","name":"blogPost_name__D0Qcn"};